export const FatalError: React.FC = () => {
  return <div>Something went wrong</div>;
};
